var _circle, _circle2, _circle3, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushButtonactiv3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#EC0303"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.41,
    cx: 26,
    cy: 26,
    r: 17,
    fill: "#EC0303"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 13,
    fill: "#970303",
    stroke: "black",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1273_4656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.0663,
    y: 17.5555,
    width: 20.4444,
    height: 20.4444,
    fill: "#970303"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1273_4656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9894 36.2963C25.5919 36.2963 25.2192 36.2111 24.8713 36.0407C24.5235 35.8703 24.2289 35.629 23.9875 35.3166L19.3449 29.4176L19.7496 28.9916C20.0335 28.6935 20.3743 28.516 20.7718 28.4592C21.1693 28.4024 21.5385 28.4805 21.8792 28.6935L23.4551 29.6518V22.6666C23.4551 22.4253 23.5368 22.223 23.7 22.0597C23.8633 21.8964 24.0656 21.8148 24.307 21.8148C24.5483 21.8148 24.7542 21.8964 24.9246 22.0597C25.0949 22.223 25.1801 22.4253 25.1801 22.6666V32.7185V33.5065L25.3292 34.2731C25.4144 34.3725 25.5138 34.4506 25.6273 34.5074C25.7409 34.5642 25.8616 34.5926 25.9894 34.5926H30.6959C31.1644 34.5926 31.5655 34.4257 31.8991 34.0921C32.2327 33.7585 32.3996 33.3574 32.3996 32.8889V29.4815C32.3996 29.2401 32.6633 33.6632 32.5 33.5C32.3367 33.3367 31.7891 35 31.5477 35H24.9246V26.9259H31.5477C32.2576 26.9259 32.861 27.1744 33.3579 27.6713C33.8548 28.1682 34.1033 28.7716 34.1033 29.4815V32.8889C34.1033 33.8259 33.7696 34.6281 33.1023 35.2953C32.4351 35.9626 31.6329 36.2963 30.6959 36.2963H25.9894ZM20.6227 24.7963C20.4382 24.4839 20.2962 24.1467 20.1968 23.7847C20.0974 23.4227 20.0477 23.05 20.0477 22.6666C20.0477 21.4882 20.463 20.4838 21.2936 19.6532C22.1241 18.8227 23.1286 18.4074 24.307 18.4074C25.4854 18.4074 26.4898 18.8227 27.3204 19.6532C28.151 20.4838 28.5662 21.4882 28.5662 22.6666C28.5662 23.05 28.5165 23.4227 28.4172 23.7847C28.3178 24.1467 28.1758 24.4839 27.9912 24.7963L26.5218 23.9444C26.6354 23.7457 26.7206 23.5433 26.7773 23.3375C26.8341 23.1316 26.8625 22.908 26.8625 22.6666C26.8625 21.9568 26.6141 21.3534 26.1172 20.8565C25.6202 20.3595 25.0169 20.1111 24.307 20.1111C23.5971 20.1111 22.9937 20.3595 22.4968 20.8565C21.9999 21.3534 21.7514 21.9568 21.7514 22.6666C21.7514 22.908 21.7798 23.1316 21.8366 23.3375C21.8934 23.5433 21.9786 23.7457 22.0922 23.9444L20.6227 24.7963Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9922 22.6391L31.68 22.4601",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5795 19.2294L29.6902 17.5556",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6582 17.6803L24.9278 15",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4737 15.955L21.6287 18.3886",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0663 20.0286L19.74 20.3562",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.0325L19.688 23.8564",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushButtonactiv3);
export default __webpack_public_path__ + "static/media/pushButtonactiv3.06ce760c5e4624a0aaec6fb1ac10bb47.svg";
export { ForwardRef as ReactComponent };